import React, { useState } from 'react'
import { Alert, Button, Card, Divider, Group, LoadingOverlay, Modal, ModalProps, Text, Title } from "@mantine/core"
import { PricingRule } from '../GlobalJobMatchingVersioning/types/rules'
import { useHistory } from 'react-router'
import { useSelectRuleAndRemoveOthers } from '../../../hooks/global-job-matching'
import { getOperatorLabel } from '../../../constants/filter-operators'

interface RuleSelectionModalProps extends ModalProps {
  rules: PricingRule[]
}

export const RuleSelectionModal = ({ opened, onClose, rules }: RuleSelectionModalProps) => {
  const [selectedRule, setSelectedRule] = useState<PricingRule | undefined>(undefined)
  const { mutate, isLoading } = useSelectRuleAndRemoveOthers({ onSuccess: onClose })
  const history = useHistory()

  const handleSelection = () => {
    const rulesToDelete = rules.filter(r => r.id !== selectedRule?.id)?.map(r => r?.id)
    mutate({ ruleIds: rulesToDelete })
  }
 
  return (
    <Modal size='1200px' withCloseButton={false} closeOnEscape={false} closeOnClickOutside={false} trapFocus={false} opened={opened} onClose={onClose}>
      <LoadingOverlay visible={isLoading} />
      <Title order={4}>Choose a Rule</Title>
      <Text mb='lg'>Please choose one rule to continue</Text>
      { rules.map(rule => (
        <Card withBorder shadow={selectedRule?.id === rule.id ? 'lg' : 'sm'} mb='lg' key={rule.id} style={{ cursor: 'pointer', borderColor: selectedRule?.id === rule.id ? 'green' : 'inherit', borderWidth: selectedRule?.id === rule.id ? '1.5px' : 'inherit' }} onClick={() => setSelectedRule(rule)}>
          <Text mb='sm'>Rule Name: {rule.name}</Text>
          <Text>Included Jobs: {rule.jobsSelection === 'all' ? 'All Jobs' : 'Select Jobs'}</Text>
          { rule.jobsSelection === 'select' && 
            <>
              <Text>Filters: </Text>
              { rule.jobsFilter?.map((filter, i) => (
                <Text key={i} ml={15}>{filter.element} {getOperatorLabel(filter.operator)} {filter.value}</Text>
              ))}
            </>
          }
          { !!rule.companiesMinimum && <Text>Companies Minimum: {rule.companiesMinimum}</Text> }
          { !!rule.incumbentsMinimum && <Text>Incumbents Minimum: {rule.incumbentsMinimum}</Text> }
          { !!rule.marketDataElements?.length && <Text>Required Data Elements: {rule.marketDataElements.join(', ')}</Text>}
        </Card>
      ))}

      { selectedRule && <Alert mb='lg' color='red' title='Warning'>Selecting a rule will delete all other rules.</Alert> }

      <Divider my='md' />
      <Group justify='flex-end' py='lg'>
        <Button variant='outline' size='lg' onClick={() => history.replace('/market-analysis/strategy-based-pricing')}>Go Back</Button>
        <Button disabled={!selectedRule} size='lg' onClick={handleSelection}>Select Rule</Button>
      </Group>
    </Modal>
  )
}
